"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/EyeHide.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EyeHide = function EyeHide(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 251.3 165.7"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Hide Eye Icon"), _react2.default.createElement("path", {
    className: "eye",
    d: "M179.1 68.2c0 29.5-24 53.5-53.5 53.5-3.866 0-7.637-.412-11.273-1.195l63.59-63.544A53.712 53.712 0 0 1 179.1 68.2zm-53.6 69.7c35.4 0 62.7-14.7 75.8-23.4 19.9-13.2 28.6-26.9 28.6-30.9-.3-4.1-9.4-17.8-29.3-31a140.54 140.54 0 0 0-11.492-6.822l16.796-16.784A150.974 150.974 0 0 1 212.5 33.2c18.7 12.6 38.8 32.5 38.8 50.5 0 8.3-3.9 17.4-11.7 27-6.8 8.4-16.1 16.7-27.1 23.9-15 10-46.3 26.8-86.9 26.8-16.944 0-32.215-2.828-45.347-6.845l19.229-19.215a133.95 133.95 0 0 0 26.018 2.56zM72.1 68.2a53.271 53.271 0 0 1 10.023-31.184C68.322 41.879 57.463 48.111 50.5 52.7c-20 13.3-29.1 26.9-29.3 31 0 3.9 7.2 17.3 28.5 31.3a132.829 132.829 0 0 0 10.925 6.475l21.764-21.764A53.21 53.21 0 0 1 72.1 68.2zM127.7 47c-.7-.4-1.4-.7-2.2-1-2-.8-4.1-1.3-6.2-1.5-1.4-.2-2.9-.2-4.3-.2-1.7 0-3.3.2-4.9.5-1.7.3-3.5.8-5.1 1.5-1.7.7-3.4 1.6-4.9 2.7-1.6 1.1-3 2.4-4.2 3.8-.3.4-.6.7-.9 1.1l-.8 1.1c-.5.7-1 1.4-1.4 2.2-.8 1.5-1.4 3-1.9 4.6-.3.7-.5 1.5-.6 2.2l-.3 2.1c-.2 1.2-.2 2.4-.2 3.6 0 1 .1 1.9.2 2.8.2 1.5.4 2.3.4 2.3s.4-.8 1-2.2c.2-.7.7-1.5 1-2.4.3-.9.9-1.9 1.4-3 .3-.5.6-1 .9-1.6.3-.6.6-1.2 1-1.7.7-1.2 1.5-2.3 2.3-3.4.9-1.1 1.8-2.1 2.8-3.1 1-1 2.1-1.9 3.3-2.7 1.2-.8 2.4-1.5 3.7-2.2.6-.3 1.2-.6 1.9-.9.7-.3 1.3-.6 2-.8 2.5-.9 5.1-1.7 7.7-2.3 2.4-.6 4.4-.9 5.9-1.2zM43 139.1l.817-.817A144.63 144.63 0 0 1 38.8 135.1C14.5 119.1 0 99.9 0 83.7c0-18 20-37.8 38.8-50.5C53.9 23 85.3 6 125.6 6c16.189 0 30.957 2.743 43.813 6.687L182.1 0l14.7 14.6L57.7 153.7l-2.9-2.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = EyeHide;